module.exports = __webpack_public_path__ + "static/media/CNY.915ff271.svg";